import {Pipe, PipeTransform} from '@angular/core';
import * as TranslateVars from './vars_translate';

@Pipe({ name: 'translate' })
export class TempConvertPipe implements PipeTransform {
  transform(value: string, args: string[]): any {
    if (!value) return value;

    return value + TranslateVars.translations_EN.CategoryName ;
  }
}


// WEBPACK FOOTER //
// A:/Work/Siti/Volpe2/src/app/common/pipe-translate.ts